import React from "react";
import { JoinMovementComponentProps } from "../../constants/interface.ts";
import { useTranslation } from "react-i18next";
import { useCustomNavigation } from "../../utility/Utility.ts";

const JoinMovementComponent = (props: JoinMovementComponentProps) => {
    const { title, paragraph, img, list, appStoreList } = props;
    const {t} = useTranslation();
    const customNavigate = useCustomNavigation();

    return (
        <div className="flex flex-col-reverse gap-8 place-items-center lg:grid lg:grid-cols-[auto,1fr] lg:gap-16">
            <img loading="lazy" src={img} alt=""
                className="min-h-full bg-gray-DDE w-full rounded-md lg:w-[35rem] lg:rounded-lg"
            />
            <div className="flex flex-col gap-8">
                <div className="flex flex-col gap-5 lg:gap-6">
                    <p className="text-3xl font-semibold text-black-1A1">{t(title)}</p>
                    <>
                    {
                        (paragraph) &&
                        <p className="text-base font-normal text-gray-535 lg:text-lg lg:max-w-[40rem]">{t(paragraph)}</p>
                    }
                    </>
                    <>
                    {
                        (list.length > 0) &&
                        <ul>
                            {
                                list.map((item, i) => (
                                    <li key={i} className="list-disc text-base font-normal text-gray-535 lg:text-lg lg:max-w-[40rem] ml-6">{t(item.paragraph)}</li>
                                ))
                            }
                        </ul>
                    }
                    </>
                </div>
                {/* As per the new requirement, we don't need to display any app redirection links.
                <div className="flex gap-3">
                    {
                        appStoreList.map((item, index: number) => (
                            <img loading="lazy" key={`JoinMovementComponent-${index}`}
                                src={item.img} alt={t(title)}
                                className="h-10 cursor-pointer"
                                onClick={() => customNavigate(false, item.link)}
                            />
                        ))
                    }
                </div>
                */}
            </div>
        </div>
    );
};

export default JoinMovementComponent;